import React from 'react'
import { FormInner, FormContainer, Form, FormHeading, FieldsWrapper, FieldDiv, SubmitWrapper } from '../styled-elements'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import { makeStyles } from '@material-ui/core/styles'
import { RoundedFormButton } from '../../../styles/styled-elements'

const FormElement = ({
                       formInputChangeHandler,
                       handleSubmit,
                       state
                     }) => {

  const useStyles = makeStyles((theme) => {
    return ({
      textFieldInput: {
        fontSize: 13,
        height: '1.4em',
      },
      textFieldInputLabel: {
        fontSize: '13px !important'
      }
    })
  })

  const classes = useStyles()

  return <FormContainer>
    <FormInner>
      <Form onSubmit={handleSubmit}>
        {state.formErrors &&
          <FormHelperText style={{ textAlign: 'center', fontSize: '1.2em' }} error>{state.formErrors}</FormHelperText>
        }
        <FieldsWrapper>
          <FieldDiv>
            <TextField
              required
              variant="standard"
              label="Referral code"
              name="code"
              inputProps={{
                autoCorrect: 'off',
                autoCapitalize: 'words',
                autoComplete: 'none',
              }}
              value={state.code || ''}
              onChange={formInputChangeHandler}
              error={state.errors && state.errors.code}
              style={{ width: '100%', marginTop: 20 }}
              InputProps={{ className: classes.textFieldInput }}
              InputLabelProps={{ className: classes.textFieldInputLabel }}
            />
            <FormHelperText error>{state.errors && state.errors.code}</FormHelperText>
          </FieldDiv>
        </FieldsWrapper>
        <SubmitWrapper>
          <RoundedFormButton enabled={(state.canSubmit)}>Accept Referral</RoundedFormButton>
        </SubmitWrapper>
      </Form>
    </FormInner>
  </FormContainer>
}


export default class UserAcceptReferralForm extends React.Component {

  constructor(props) {
    super(props);

    const params = new URLSearchParams(window.location.search);
    const referralCode = params.get('referral_code');

    this.state = {
      code: referralCode ?? '',
      hasChanged: false,
      canSubmit: referralCode,
      hasErrors: false,
      formErrors: null,
      errors: null
    }
  }

  componentDidMount(prevProps) {
  }

  componentDidUpdate(prevProps, prevState) {
    const { props, state } = this
    const stateHash = {}
    let canSubmit = false
    if (this.state !== prevState) {
      if (this.state.code) {
        canSubmit = true
      }
      if (canSubmit !== state.canSubmit) {
        stateHash['canSubmit'] = canSubmit
      }
    }
    if (Object.keys(stateHash).length) {
      this.setState(stateHash)
    }
  }

  formInputChangeHandler = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      hasChanged: true,
    })
  }

  validate = (callback) => {
    const errors = {}
    const code = this.state.code;
    if (!code) {
      errors.code = 'Referral code is required'
    }
    if (Object.keys(errors).length) {
      this.setState({
        hasErrors: true,
        errors: errors
      })
    } else {
      callback.call(this)
    }
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.setState({
      hasErrors: false,
      formErrors: null,
      errors: null,
    })
    this.validate(() => {
      this.props.submitHandler.call(this, { referralCode: this.state.code });
    })
  }

  updateLoading = (value) => {
    this.setState({ loading: !!value })
  }

  renderBody = (props, state) => <FormElement
    formInputChangeHandler={this.formInputChangeHandler}
    handleSubmit={this.handleSubmit}
    state={state}
  />

  render() {
    return this.renderBody(this.props, this.state)
  }
}
